import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

const HOTELS = 'assets/images/pmax-preview-hotels/';

/**
 * Performance Max on a Display Network site (desktop): a single hotel card in
 * the sidebar, under the long headline. The hotel is a static placeholder.
 */
@Component({
  selector: 'app-pmax-display-desktop-03',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './display-desktop-03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-desktop-03.component.scss'
})
export class PmaxDisplayDesktop03PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton nav bars under the site name. */
  readonly navItems = [0, 1, 2, 3];

  /** Skeleton text lines above the article image, as % widths. */
  readonly articleLines = [100, 100, 100, 100, 75];

  readonly hotel = { image: HOTELS + 'pical.jpg', title: 'Valamar Tirena Hotel', subtitle: 'Najbolja cijena' };

  get longHeadline(): string {
    return this.data.longHeadlines[0] || 'Your long headline appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
